import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';


class RcvRptStore extends EventEmitter {
    PageLoadData = ""
    Excel = ""
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleOrderStatusStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.ReceivingReport_PageLoad: {
                this.PageLoadData = action.action.response;
                this.emit('RRPageLoad');
                break;
            }
            case SDIConstants.methodNames.ReceivingReport_GoButtonClick: {
                this.PageLoadData = action.action.response;
                this.emit('Go');
                break;
            }
            case "ORDERSTS_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
                //WBW - 11 Receiving Report - Excel Change - Deepthi N H
            case "Export": {
                this.Excel = action.action.response;
                ;
                this.emit('Export');
                break;
            }
        }
    }
}
const objRcvRptStore = new RcvRptStore;
// Dispatcher code
Dispatcher.register(objRcvRptStore.handleOrderStatusStore.bind(objRcvRptStore));
export default objRcvRptStore;